stimulusApp.register(
  "cookie-consent",
  class extends Stimulus.Controller {
    close(event) {
      event.preventDefault()
      // Stop propagation to avoid closing Auth modal by closing Consent block
      event.stopPropagation()
      this.element.remove()
    }
  },
)
